<template>
  <div>
    <h4 class="site-heading my-3"><span>Faqs</span></h4>
    <div class="form-row align-items-end" v-for="(faq, index) in fquestions">
      <div class="form-group col-md-11 required">
        <label class="control-label">Question</label>
        <input
          type="text"
          id="faq.question"
          name="faq.question"
          v-bind:class="{ 'has-error': errors.has('faq.id') }"
          v-validate="'required'"
          v-model="faq.question"
          class="form-control faq.question"
          placeholder="Question"
        />
        <div class="help text-danger" v-show="errors.has('faq.id')">
          {{ errors.first("faq.id") }}
        </div>
      </div>
      <div class="form-group col-md-11 required">
        <label class="control-label">Answer</label>
        <input
          type="text"
          id="faq.answer"
          name="faq.answer"
          v-bind:class="{ 'has-error': errors.has('faq.id') }"
          v-validate="'required'"
          v-model="faq.answer"
          class="form-control faq.answer"
          placeholder="Answer"
        />
        <div class="help text-danger" v-show="errors.has('faq.id')">
          {{ errors.first("faq.id") }}
        </div>
      </div>
      <div class="form-group col-md-11 required">
        <label class="control-label">Display Order</label>
        <input
          type="text"
          id="faq.display_order"
          name="faq.display_order"
          v-bind:class="{
            'has-error': errors.has('faq.display_order'),
          }"
          v-validate="'required'"
          v-model="faq.display_order"
          class="form-control faq.display_order"
          placeholder="Display Order"
        />
        <div class="help text-danger" v-show="errors.has('faq.display_order')">
          {{ errors.first("faq.display_order") }}
        </div>
      </div>
      <div class="form-group col-md-1">
        <button
          type="button"
          class="btn btn-danger float-right"
          @click="deleteFaq(index)"
        >
          <i class="fa fa-trash"></i>
        </button>
      </div>
    </div>
    <button type="button" @click="addFaq" class="btn btn-success">
      <i class="fa fa-plus"></i> New
    </button>
  </div>
</template>
<script>
export default {
  props: ["faqs"],
  data: () => ({
    fquestions: [],
  }),
  methods: {
    addFaq: function () {
      this.fquestions.push({});
    },
    deleteFaq: function (index) {
      this.fquestions.splice(index, 1);
    },
  },
  watch: {
    faqs: function (val, oldVal) {
      this.fquestions = val;
    },
  },
  updated() {
    this.$emit("updateFaqs", this.fquestions);
  },
};
</script>
